import Breadcrumb from '../../core/components/UI/Breadcrumb'
import { useCountryContext } from '../../core/context/country/CountryProvider'
import FormCreateOpportunity from '../components/opportunity-create-page/FormCreateOpportunity'
import FormUpdateCountryOpportunitySource from '../components/update-country-opportunity-source/FormUpdateCountryOpportunitySource'

export default function     UpdateCountryOpportunitySource() {
  const { countryState } = useCountryContext()
  return (
    <>
      <Breadcrumb
        links={[
          {
            id: 1,
            label: 'المناطق',
            isActive: false,
            to: `/countries/opportunities`,
          },
          {
            id: 2,
            label: countryState.country?.name_ar,
            isActive: false,
            to: `/countries/opportunities`,
          },
          {
            id: 3,
            label: 'الفرص الاستثمارية',
            isActive: false,
            to: '/countries/opportunities',
          },
          {
            id: 4,
            label: ' إضافة مصدر',
            isActive: true,
          },
        ]}
      />
       <div className="p-2 bg-white border-2 border-muted-500">
        <FormUpdateCountryOpportunitySource />
       </div>
    </>
  )
}
